export default __webpack_public_path__ + "static/media/aluxus_2.471790c0.jpg";